import { adminData } from "~/admin/data";

export const PROPS_CAN_DELETE = adminData.PROPS_CAN_DELETE;

export const PROPS_QUERY_ID = "queryId";

export const PROPS_NAME = "name";

export const PROPS_DESCRIPTION = "description";

export const PROPS_LAST_MODIFIED = "modifiedDate";

export const PROPS_FILE_NAME = "fileName";

export const PROPS_OUTPUT_URL = "outputUrl";

export const PROPS_FREQUENCY = "frequency";

export const PROPS_DAY_OF_WEEK = "dayOfWeek";

export const PROPS_DAY_OF_MONTH = "dayOfMonth";

export const PROPS_QUERY_TEXT = "queryText";
